<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" :query-api="queryApi"
                                           :ignoreMaxTableItemLimit="true"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolPoResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" :query-api="queryApi" :ignoreMaxTableItemLimit="true"
                                      :ignoreAdd="true" :ignoreDelete="true" :editDisable="true"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      :custom-form-class="customFormClass"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2022-01-27 17:10:16

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import PageMaterialDownloadBomDrawingMixin from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";

export default {
    name: "sithMesStoolPoCpmListView",
    components: {MiniButton},
    mixins: [emCommonListMixin, emCustomVuexMixin, PageMaterialDownloadBomDrawingMixin],
    data() {
        return {
            queryApi: 'findAllWithPriceByFilter',
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        },
        $_emCustomVuexMixin_vo: {
            type: String,
            default: 'cpmVo'
        },
        $_emCustomVuexMixin_filter: {
            type: String,
            default: 'cpmFilter'
        },
    },
    computed: {
        modelName() {
            return 'sithMesStoolPo'
        },
        $_rowMaterialKey() {
            return 'materialNumber';
        },
        $_customVuexName() {
            return 'cpm';
        },
    },
    mounted() {
        this.$refs["emListFilter"].doQuery();
    },
    methods: {
        customFormClass: (col, row) => {
            if (col.key === 'prdScheduleDate' && row.hasUnReadRequireDateChangeHistory === true) {
                return 'bg-danger text-white';
            }
            return '';
        },
    }
};
</script>
